// What can be dragged onto a workspace, as the drag carries it: a session
// ({ id, title }), a finding ({ id, session, title, sessionTitle }), a
// machine ({ id, name, sessions }), or a whole workspace ({ id, title }),
// which goes inside the one it is dropped on. A finding also travels as its
// session, so anything that takes a session takes it.
export const SESSION_DRAG_TYPE = "application/x-origin-session";
export const FINDING_DRAG_TYPE = "application/x-origin-finding";
export const MACHINE_DRAG_TYPE = "application/x-origin-machine";
export const WORKSPACE_DRAG_TYPE = "application/x-origin-workspace";
const TYPES = [WORKSPACE_DRAG_TYPE, FINDING_DRAG_TYPE, MACHINE_DRAG_TYPE, SESSION_DRAG_TYPE];

export const draggingItem = (e) => {
  const types = [...(e.dataTransfer?.types || [])];
  return TYPES.some((t) => types.includes(t));
};

// What is being dragged now, in droppedItem's shape: a drag's data can only be
// read once it is dropped, and a board shows where it would land while it is
// carried over it. Set as a drag starts here; let go of as any drag ends.
let dragging = null;
export const draggedItem = () => dragging;
if (typeof window !== "undefined") {
  const ended = () => { dragging = null; };
  window.addEventListener("dragend", ended, true);
  window.addEventListener("drop", () => setTimeout(ended, 0), true);
}
const shapeOf = (item) => {
  if (item.kind === "workspace") return { kind: "workspace", id: item.id, title: item.title || "", sessions: [] };
  if (item.kind === "finding") return { kind: "finding", id: item.id, session: item.session, title: item.title || "", sessionTitle: item.sessionTitle || "", sessions: item.session ? [{ id: item.session, title: item.sessionTitle || "" }] : [] };
  if (item.kind === "machine") return { kind: "machine", id: item.id, name: item.name || "", sessions: (item.sessions || []).filter((x) => x?.id) };
  return { kind: "session", id: item.id, title: item.title || "", sessions: item.id ? [{ id: item.id, title: item.title || "" }] : [] };
};

export function setDragItem(e, item) {
  if (!e.dataTransfer || !item) return;
  dragging = shapeOf(item);
  e.dataTransfer.effectAllowed = "copy";
  if (item.kind === "workspace") {
    e.dataTransfer.setData(WORKSPACE_DRAG_TYPE, JSON.stringify({ id: item.id, title: item.title || "" }));
  } else if (item.kind === "finding") {
    e.dataTransfer.setData(FINDING_DRAG_TYPE, JSON.stringify({ id: item.id, session: item.session, title: item.title || "", sessionTitle: item.sessionTitle || "" }));
    e.dataTransfer.setData(SESSION_DRAG_TYPE, JSON.stringify({ id: item.session, title: item.sessionTitle || "" }));
  } else if (item.kind === "machine") {
    e.dataTransfer.setData(MACHINE_DRAG_TYPE, JSON.stringify({ id: item.id, name: item.name || "", sessions: item.sessions || [] }));
  } else {
    e.dataTransfer.setData(SESSION_DRAG_TYPE, JSON.stringify({ id: item.id, title: item.title || "" }));
  }
  e.dataTransfer.setData("text/plain", item.kind === "machine" ? item.name || item.id : item.title || item.id);
}

// What a drop brings, with the sessions it lays on (the first the one a
// workspace opens on): null when it is none of these.
export function droppedItem(e) {
  const read = (type) => {
    try { return JSON.parse(e.dataTransfer?.getData(type) || "null"); } catch { return null; }
  };
  const workspace = read(WORKSPACE_DRAG_TYPE);
  if (workspace?.id) return { kind: "workspace", ...workspace, sessions: [] };
  const finding = read(FINDING_DRAG_TYPE);
  if (finding?.session) return { kind: "finding", ...finding, sessions: [{ id: finding.session, title: finding.sessionTitle || "" }] };
  const machine = read(MACHINE_DRAG_TYPE);
  if (machine?.id && Array.isArray(machine.sessions)) return { kind: "machine", ...machine, sessions: machine.sessions.filter((s) => s?.id) };
  const session = read(SESSION_DRAG_TYPE);
  if (session?.id) return { kind: "session", ...session, sessions: [{ id: session.id, title: session.title || "" }] };
  return null;
}
